import { z } from "zod";
import { zCorpAdminStatus } from "@/types/corp/corpSession.common";
export const zCorpAdminDom = z.object({
    adminId: z.string(),
    email: z.string(),
    fullName: z.string(),
    phone: z.string().nullable(),
    status: zCorpAdminStatus,
    blockedAt: z.string().nullable(),
    blockReason: z.string().nullable(),
    createdAt: z.string(),
    companyIds: z.array(z.string()),
    companyNames: z.array(z.string()),
});
export const CORP_ADMIN_MIN_PASSWORD_LENGTH = 8;
